<script setup lang="ts">
defineProps<{
  alertMessage: string
}>()

const emit = defineEmits<{
  closeAlert: []
}>()
</script>

<template>
  <dialog class="qq-alert-dialog-selector">
    <div class="qq-dialog-message-selector">{{ alertMessage }}</div>
    <div class="qq-dialog-buttons">
      <button type="button" class="qq-cancel-button-selector" @click="emit('closeAlert')">Close</button>
    </div>
  </dialog>
  <dialog class="qq-confirm-dialog-selector">
    <div class="qq-dialog-message-selector"></div>
    <div class="qq-dialog-buttons">
      <button type="button" class="qq-cancel-button-selector">No</button>
      <button type="button" class="qq-ok-button-selector">Yes</button>
    </div>
  </dialog>
  <dialog class="qq-prompt-dialog-selector">
    <div class="qq-dialog-message-selector"></div>
    <input type="text">
    <div class="qq-dialog-buttons">
      <button type="button" class="qq-cancel-button-selector">Cancel</button>
      <button type="button" class="qq-ok-button-selector">Ok</button>
    </div>
  </dialog>
</template>
